<template>
  <v-card key="title-card" class="rounded-xl" elevation="0" outlined>
    <v-row class="test">
      <v-col cols="12" md="6">
        <the-avatar-portfolio/>
      </v-col>
      <v-col cols="12" md="6" class="d-flex justify-end align-content-end">
        <v-card-actions>
          <the-action-title-portfolio/>
        </v-card-actions>
      </v-col>
    </v-row>
    <v-card-actions>
      <the-tabs-title-profile/>
    </v-card-actions>
  </v-card>
</template>

<script>
import {mapActions} from "vuex";

const TheAvatarPortfolio = () => import("./CardTitlePortfolio/TheAvatarPortfolio.vue");
const TheTabsTitleProfile = () => import("./CardTitlePortfolio/TheTabsTitleProfile.vue");

const TheActionTitlePortfolio = () => import("./CardTitlePortfolio/TheActionTitlePortfolio.vue");

export default {
  name: "TitleCard",

  components: {
    TheAvatarPortfolio,
    TheTabsTitleProfile,
    TheActionTitlePortfolio,
  },

  data() {
    return {
    }
  },

  mounted () {

  },

  computed: {

  },

  methods: {
    ...mapActions({
      setDialogAction: 'achievement/setDialogAction',
    })
  },
}
</script>

<style scoped>
.test {

}
</style>